// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

.input-group_input-group_I38OZ {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

[dir='ltr'] .input-group_input-group_I38OZ + .input-group_input-group_I38OZ {
  margin-left: calc(2 * 0.25rem);
}

[dir='rtl'] .input-group_input-group_I38OZ + .input-group_input-group_I38OZ {
  margin-right: calc(2 * 0.25rem);
}

.input-group_disabled_CQosl {
  opacity: 0.3;
  /* Prevent any user actions */
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/input-group/input-group.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;AACtB","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n.input-group {\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n[dir='ltr'] .input-group + .input-group {\n  margin-left: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .input-group + .input-group {\n  margin-right: calc(2 * 0.25rem);\n}\n\n.disabled {\n  opacity: 0.3;\n  /* Prevent any user actions */\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-group": `input-group_input-group_I38OZ`,
	"inputGroup": `input-group_input-group_I38OZ`,
	"disabled": `input-group_disabled_CQosl`
};
export default ___CSS_LOADER_EXPORT___;
